import React, { useState } from 'react';
import styles from './AdminCommentSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { userSingle } from '../../../redux/actions/user/userSingle';
import { resetUserSingle } from '../../../redux/slices/user.slice';
import { resetCommentSingle, resetDiscountSingle, resetPostSingle } from '../../../redux/slices/app.slice';
import { postSingle } from '../../../redux/actions/app/postSingle';
import dayjs from 'dayjs';
import { discountSingle } from '../../../redux/actions/app/discountSingle';
import { commentSingle } from '../../../redux/actions/app/commentSingle';

const AdminCommentSingle = () => {
  const data = [
    {
      label: 'Фото',
      type: 'image',
      name: 'image',
      width: '500px',
    },
    {
      label: 'Название',
      type: 'text',
      name: 'title',
      disabled: true,
    },
    [
      {
        type: 'image',
        name: 'avatar',
        width: '40px',
        grid: '40px 1fr',
      },
      {
        label: 'Создатель',
        type: 'text',
        name: 'user',
        disabled: true,
      },
    ],
    {
      label: 'Описание',
      type: 'textarea',
      name: 'description',
      disabled: true,
    },
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ discount: { title, image, description, club, createdAt } }) => {
    setFields(data);
    return { title, image, description, user: club?.name, avatar: club?.logo };
  };

  return (
    <>
      <AdminSinglePage reset={resetCommentSingle} fetch={commentSingle} sliceName={'app'} actionName={'discountSingle'} onFormatData={onFormatData} fields={fields} />
    </>
  );
};

export default AdminCommentSingle;
